// Rails functionality
import "@hotwired/turbo-rails"
import * as ActiveStorage from "@rails/activestorage"
ActiveStorage.start()

import "./channels/consumer"
import "trix"
import "@rails/actiontext"

// Stimulus controllers
import "./controllers"

// Jumpstart Pro & other Functionality
import "./src/actiontext"
import "./src/confirm"
import "./src/direct_uploads"
import "./src/forms"
import "./src/timezone"
import "./src/tooltips"
import "./src/john_hancock"

import LocalTime from "local-time"
LocalTime.start()

// Leaflet map icons
import L from "leaflet"
import markerIcon2x from "leaflet/dist/images/marker-icon-2x.png"
import markerIcon from "leaflet/dist/images/marker-icon.png"
import markerShadow from "leaflet/dist/images/marker-shadow.png"

delete L.Icon.Default.prototype._getIconUrl
L.Icon.Default.mergeOptions({
  iconRetinaUrl: markerIcon2x,
  iconUrl: markerIcon,
  shadowUrl: markerShadow,
})

window.initMap = function (...args) {
  const event = document.createEvent("Events")
  event.initEvent("google-maps-callback", true, true)
  event.args = args
  window.dispatchEvent(event)
}
